export const PREPOSTO = 1;
export const FRANQUEADO_PLANEJADOR = 2;
export const FRANQUEADO_EXPANSAO = 3;
export const CLT = 4;
export const PJ = 5;
export const GERADOR_LEADS = 6;
export const FRANQUEADO_RECOMENDADOR = 7;
export const FRANQUEADO_VENDEDOR = 8;